<template>
  <div class="settle-manager" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="100px">
      <el-form-item label="盘点月份" prop="queryDate">
        <el-date-picker v-model="form.queryDate" type="month" placeholder="请选择年月" format="yyyy-MM" value-format="yyyy-MM" :picker-options="{ disabledDate (time) { return time.getTime() > Date.now() } }" style="width: 100%" />
      </el-form-item>
      <el-form-item label="库区名称" prop="oilDepotCode">
        <el-select v-model="form.oilDepotCode">
          <el-option v-for="item in oilDepotOptions" :key="item.code" :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="油罐编码" prop="oilTankCode">
        <el-select v-model="form.oilTankCode" clearable>
          <el-option v-for="item in formOilTankOptions" :key="item.oilTankCode" :label="item.oilTankCode"
            :value="item.oilTankCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button type="primary" @click="handleEdit">变更</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" tooltip-effect="light" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="reservoirAreaName" label="库区名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="reservoirAreaCode" label="库区编码" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="oilTankCode" label="油罐编码" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="operateDateStart" label="盘点开始时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="operateDateEnd" label="盘点结束时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="lossRate" label="合理损耗率" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="practicalQuantity" label="当月实际库存" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="additiveAccount" label="助剂账面数" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="additiveUse" label="助剂使用数" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="additiveQuantity" label="助剂库存数" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="memo" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="handlePush(scope.row)">操作记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :page-sizes="[10, 20, 50, 100]" :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="listState.total" :current-page="listState.pageNo"
      background @current-change="handleCurrentChange" @size-change="handleSizeChange">
    </el-pagination>
    <add-or-edit-dialog :show.sync="dialogVisible" :info="printDialogInfo" :reservoirAreaOptions="reservoirAreaOptions"
      :oilTankOptions="oilTankOptions" :oilTankData="oilTankData" @reload="handleSearch">
    </add-or-edit-dialog>
    <el-dialog :visible.sync="historyShow" width="800px">
      <el-table :data="historyTableData" style="width: 100%" tooltip-effect="light">
        <el-table-column prop="reservoirAreaName" label="库区名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="reservoirAreaCode" label="库区编码" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="oilTankCode" label="油罐编码" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="operateDateStart" label="盘点开始时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="operateDateEnd" label="盘点结束时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="lossRate" label="合理损耗率" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="practicalQuantity" label="当月实际库存" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="additiveAccount" label="助剂账面数" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="additiveUse" label="助剂使用数" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="additiveQuantity" label="助剂库存数" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="memo" label="备注" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import HttpUtil from '@/common/HttpUtil'
import addOrEditDialog from './addOrEditDialog.vue'
export default {
  name: 'inventoryXnyLoss',
  components: { addOrEditDialog },
  data () {
    return {
      form: {},
      dialogVisible: false,
      oilTankOptions: [],
      formOilTankOptions: [],
      printDialogInfo: {},
      reservoirAreaOptions: [],
      oilTankData: [],
      reservoirAreaCode: 'XNYYPK',
      multipleSelection: [],
      tableData: [],
      historyTableData: [],
      total: 0,
      listState: {
        pageSize: 10,
        pageNo: 1
      },
      oilDepotOptions: [
        { code: 'PJPSK', name: '盘锦盘山油库' },
        { code: 'JHK', name: '天津静海油库' },
        { code: 'CMK', name: '山西昌茂油库' }
      ],
      historyShow: false
    }
  },

  methods: {
    ...mapActions(['getDicTankList', 'getDicOilTankList']),
    enterSearch (e) {
      // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleAdd () {
      this.dialogVisible = true
      this.printDialogInfo = {}
    },
    handleEdit () {
      if (this.multipleSelection.length === 1) {
        this.dialogVisible = true
        this.printDialogInfo = this.multipleSelection[0]
      } else {
        this.updateDialog = false
        this.$message.warning('请选择一条数据')
      }
    },
    // 处理HTTP请求错误
    handleRequestError (error) {
      console.error('请求错误:', error)
      this.$message.error('操作失败，请重试')
    },

    // 通用的分页查询函数
    fetchData (params = {}) {
      const searchParams = {
        // startTime: this.form.queryDate && this.form.queryDate[0],
        // endTime: this.form.queryDate && this.form.queryDate[1],
        endTime: this.form.queryDate,
        reservoirAreaCode: this.form.oilDepotCode,
        oilTankCode: this.form.oilTankCode,
        status: 0,
        ...this.listState,
        ...params
      }

      HttpUtil.post('manage/lifonda/inventoryXnyLoss/page', searchParams)
        .then((res) => {
          if (res && res.data) {
            const { list, total, pageNum, pageSize } = res.data
            this.tableData = list || []
            this.listState.total = total || 0
            this.listState.pageNo = pageNum || 1
            this.listState.pageSize = pageSize || 10
          }
        })
        .catch(this.handleRequestError)
    },

    // 搜索
    handleSearch () {
      this.listState.pageNo = 1 // 重置页码
      this.fetchData()
    },

    // 分页条数变更
    handleSizeChange (val) {
      this.fetchData({ pageSize: val, pageNo: 1 })
    },

    // 分页跳转
    handleCurrentChange (val) {
      this.fetchData({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handlePush (row) {
      const params = {
        reservoirAreaCode: row.reservoirAreaCode,
        oilTankCode: row.oilTankCode,
        status: 1
      }
      HttpUtil.post('manage/lifonda/inventoryXnyLoss/page', params).then(
        (res) => {
          const { list } = res.data
          this.historyTableData = list
        }
      )
      this.historyShow = true
    },
    handleClose () {
      this.historyTableData = []
      this.historyShow = false
    },
    // 初始化油罐数据
    initOilTankData (reservoirAreaCode = this.reservoirAreaCode) {
      this.getDicOilTankList({ reservoirAreaCode })
        .then((res) => {
          if (res && Array.isArray(res)) {
            const temp = res.map((item) => ({
              oilTankCode: item.oilTankCode,
              oilTankName: item.oilTankName
            }))
            this.oilTankData = res
            this.oilTankOptions = temp
            this.formOilTankOptions = temp
          }
        })
        .catch(this.handleRequestError)
    },
    // 初始化库区数据
    initReservoirAreaData () {
      this.getDicTankList()
        .then((res) => {
          if (res && Array.isArray(res)) {
            this.reservoirAreaOptions = res.map((item) => ({
              reservoirAreaCode: item.reservoirAreaCode,
              reservoirAreaName: item.reservoirAreaName
            }))
          }
        })
        .catch(this.handleRequestError)
    }
  },

  mounted () {
    this.handleSearch()
    this.initReservoirAreaData()
    this.initOilTankData()
  },

  watch: {
    $route () {
      this.handleSearch()
      this.initOilTankData()
    }
  }
}
</script>
<style scoped>
.upload-btn {
  display: inline-block;
  margin: 0 10px;
}

.export-row {
  margin-top: 10px;
}
</style>
